module.exports = __webpack_public_path__ + "static/img/1.37f0b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image/1.jpg
// module id = acfO
// module chunks = 39